import { useSelector } from "react-redux";
import "./../utils/Style/component/PaymentConfirmationPrePaid.scss";
import { useState } from "react";

const PaymentConfirmationPrePaid = () => {
  const data = useSelector((state) => state?.billsPage?.prepaidRes);
  const [copied, setCopied] = useState(false);
  const copyToClipboard = () => {
    const tempInput = document.createElement("input");
    tempInput.value = data?.code;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    setCopied(true);

    // Reset the copied state after 3 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };
  const copyToClipboard2 = (shareCode) => {
    const subject = encodeURIComponent("Check out this code!");
    const body = encodeURIComponent(shareCode);
    const url = `mailto:?subject=${subject}&body=${body}`;
    window.location.href = url;
  };
  return (
    <div id="PaymentConfirmationPrePaid">
      <div className="bodySection">
        <img className="SuccessImg" src="/Images/bills/SuccessImg.png" alt="Bundle" />
        <div className="bigTitle">Payment Successful</div>
        <div className="descriptio">{data?.Message}</div>

        <div className="br"></div>

        <div className="copyTitle">To recharge your prepaid number: </div>
        {data?.glCode !== 102 && <div className="copyDesc">Copy the 14-digit secret code below</div>}

        <div className="copySerialBtn">
          <div></div>
          <div className="serial">{data?.code}</div>
          <img
            style={{ cursor: "pointer" }}
            onClick={() => {
              copyToClipboard2(data?.code);
            }}
            className="copySerial"
            src="/Images/bills/copySerial.png"
            alt="copySerial"
          />
        </div>
        {data?.glCode === 102 && (
          <div className="copySerialBtn">
            <div></div>
            <div className="serial">{data?.password}</div>
            <img
              style={{ cursor: "pointer" }}
              onClick={() => {
                copyToClipboard2(data?.password);
              }}
              className="copySerial"
              src="/Images/bills/copySerial.png"
              alt="copySerial"
            />
          </div>
        )}
        {data?.glCode !== 102 && (
          <button
            id="closeModalBtn"
            className="mt-3"
            style={{ width: "100%" }}
            onClick={() => {
              copyToClipboard();
            }}
          >
            Copy Code
          </button>
        )}
        {copied && <div className="copied">Copied!</div>}
        {data?.glCode !== 102 && (
          <div className="stepsToRecharge">
            <div className="steps">
              <div className="dot"></div>
              <div className="textStep">Go to your phone tab</div>
            </div>
            <div className="steps">
              <div className="dot"></div>
              <div className="textStep">Paste the code</div>
            </div>
            <div className="steps">
              <div className="dot"></div>
              <div className="textStep">Tap Call</div>
            </div>
            <div className="steps">
              <div className="dot"></div>
              <div className="textStep">Your mobile prepaid line is now recharged</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentConfirmationPrePaid;
